import {utils} from './utils'

const BootstrapTweaks = () => {

  const handleModals = (freezeScrollOnOpen = false) => {

    const modals = document.querySelectorAll('.modal')
    const offcanvasElements = document.querySelectorAll('.offcanvas')
    const offcanvasBgElements = document.querySelectorAll('.offcanvas-backdrop')

    modals.forEach(modal => {
      document.body.appendChild(modal)

      if(freezeScrollOnOpen){
        modal.addEventListener('hide.bs.modal', function () {
          utils.enableScroll()
        })
        modal.addEventListener('show.bs.modal', function () {
          utils.disableScroll()
        })
      }
    })

    offcanvasElements.forEach(offcanvas => {
      document.body.appendChild(offcanvas)
    })

    offcanvasBgElements.forEach(offcanvas => {
      document.body.appendChild(offcanvas)
    })
  }

  const addFloatingLabelsToForms = (jQuery) => {
    jQuery(document).on('gform_post_render', function () {
      // Check if there are Gravity Form fields
      if (document.querySelectorAll('.gfield').length > 0) {
        document.querySelectorAll('.gfield').forEach((field) => {
          const inputTypes = [
            '.ginput_container_text',
            '.ginput_container_email',
            '.ginput_container_phone',
            '.ginput_container_password',
            '.ginput_container_textarea'
          ];
      
          // Handle individual input types
          inputTypes.forEach((type) => {
            const target = field.querySelector(type);
            if (target) {
              target.classList.add('form-floating'); // Add Bootstrap's floating label class
      
              // Move label inside the form-floating container
              const label = field.querySelector('label');
              if (label) {
                target.appendChild(label);
      
                // Add placeholder if needed (required for floating labels to work)
                const input = target.querySelector('input, textarea, select');
                if (input) {
                  if (!input.hasAttribute('placeholder')) {
                    input.setAttribute('placeholder', label.textContent.trim());
                  }
      
                  // Add Bootstrap's floating label class
                  input.classList.add('form-control');
                }
              }
            }
          });
      
          // Handle complex name fields (child fields)
          if (field.classList.contains('gfield--type-name')) {
            const complexContainer = field.querySelector('.ginput_complex');
            if (complexContainer) {
              // Add the Bootstrap row class to the complex container
              complexContainer.classList.add('row');
      
              complexContainer.querySelectorAll('span').forEach((childField) => {
                const input = childField.querySelector('input');
                const label = childField.querySelector('label');
      
                if (input && label) {
                  // Wrap child field in form-floating container
                  const wrapper = document.createElement('div');
                  wrapper.classList.add('form-floating', 'col-lg-6', 'mb-0');
      
                  // Configure input
                  input.setAttribute('placeholder', label.textContent.trim());
                  input.classList.add('form-control');
      
                  // Append input and label to wrapper
                  wrapper.appendChild(input);
                  wrapper.appendChild(label);
      
                  // Replace the original span with the new wrapper
                  childField.replaceWith(wrapper);
                }
              });
            }
          }
        });
  
        // Swap submit button classes
        const submitButton = document.querySelector('.gform_footer .gform_button');
        if (submitButton) {
          submitButton.classList.remove('btn-primary');
          submitButton.classList.add('btn-outline-secondary');
        }
      }
    });
  };

  return {
    handleModals,
    addFloatingLabelsToForms
  }

}

export const bootstrapTweaks = BootstrapTweaks()